import { render, staticRenderFns } from "./CardRules.vue?vue&type=template&id=5a8e2035&"
import script from "./CardRules.vue?vue&type=script&lang=ts&"
export * from "./CardRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports